'use strict'

const container = $('.notification-messages_container');

/**
 * creates and show an notification message from backend
 * @param {string} notificationPayload - Data to create the notification
 */
function showNotification(notificationPayload) {
    let { element } = notificationPayload;
    if (element) {
        element.fadeIn(100, function(){
            element.addClass(["notification-displayed"])
        }).delay(4000).fadeOut('slow');
    }
}

/**
 * creates and show an notification message from client
 * @param {string} notificationPayload - Data to create the notification
 */
function showNotificationClient(payload) {
    if (payload) {
        let delay = payload.delay ? payload.delay : 4000;
        let cssClass = payload.cssClass ? payload.cssClass : '';
        let notification = $(`
            <div class="notification notification_floating ${cssClass} notification--${payload.type}">
                <div class="notification-content">
                    <div class="notification-message">
                        ${payload.message}
                    </div>
                </div>
            </div>
        `);
        container.append(notification);

        notification.fadeIn(100, function(){
            notification.addClass(["notification-displayed"])
        }).delay(delay).fadeOut('slow');
    }
}

function initMessaging() {
    $("[data-onloadnotificationpayload]:not(.notification-displayed)").each(function() {
        var payload = $(this).data('onloadnotificationpayload');
        payload.element = $(this);
        $(document).trigger('showNotification', payload);
    });
}

function addShowNotificationListener(){
    $(document).on('showNotification', function(e, notificationPayload) {
        showNotification(notificationPayload);
    });

    $(document).on('showNotificationClient', function(e, notificationPayload) {
        showNotificationClient(notificationPayload);
    });
}

module.exports = {
    addShowNotificationListener: addShowNotificationListener,
    initMessaging: initMessaging
}


